<div style="height:3.875rem">
  <app-top-bar></app-top-bar>
</div>
<p-toast [style]="{marginTop: '30px'}" position="top-center"></p-toast>

<div>
  <router-outlet></router-outlet>
</div>
<app-shopping-list-print-layout></app-shopping-list-print-layout>